import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Scale } from "lucide-react";

const F = [
  ["legal_company_name", "Legal company name"],
  ["data_controller", "Data Controller"],
  ["privacy_email", "Privacy contact email"],
  ["company_address", "Company address"],
  ["data_location_note", "Data location note"],
  ["privacy_version", "Privacy Policy version"],
  ["privacy_effective_date", "Privacy effective date"],
  ["terms_version", "Terms version"],
  ["terms_effective_date", "Terms effective date"],
];

export const LegalConfigCard = () => {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/platform/legal").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;
  const set = (k, v) => setCfg((c) => ({ ...c, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/platform/legal", cfg);
      setCfg(data);
      toast.success("Legal configuration saved — users on the old privacy version will be asked to re-accept");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };

  return (
    <Card className="p-6 border-slate-200" data-testid="legal-config-card">
      <div className="flex items-center gap-2"><Scale className="h-4 w-4 text-[#2563EB]" /><h3 className="text-sm font-semibold text-slate-900">Privacy &amp; Legal</h3></div>
      <p className="text-xs text-slate-500 mt-1">Company/legal entity used in the Privacy Policy &amp; Terms templates. These texts are drafts and require legal review before external commercial use.</p>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {F.map(([k, label]) => (
          <div key={k}>
            <Label className="text-[11px] text-slate-500">{label}</Label>
            <Input className="h-9 mt-1" value={cfg[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`legal-${k}`} />
          </div>
        ))}
      </div>
      <div className="mt-4 flex items-center justify-between gap-4 flex-wrap">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <Switch checked={!cfg.is_draft} onCheckedChange={(v) => set("is_draft", !v)} data-testid="legal-published-switch" />
          Mark as legally reviewed (removes the draft banner)
        </label>
        <Button onClick={save} disabled={busy} className="bg-[#2563EB] hover:bg-[#1d4ed8]" data-testid="legal-save-btn">{busy ? "Saving…" : "Save"}</Button>
      </div>
    </Card>
  );
};
